import React from "react";
import { Col } from "react-bootstrap";
import Container from "pages/_components/Container";
import SelectField from "pages/_components/fields/Select";
import Button from "pages/_components/Button";
import { Form, withFormik } from "formik";
import { actions as accountsActions, selectors } from "reducers/accounts";
import { connect } from "react-redux";
import { bool, func, instanceOf } from "prop-types";
import { useYearMonth } from "./useYearMonth";

const FORM_ID = "period.filter";

const YearMonthFilter = ({ dispatch, years, months, handleCloseSearch, specialFilter }) => {
    const { selectedFilter, handleChange, handleSearch, handleReset } = useYearMonth(
        dispatch,
        accountsActions,
        handleCloseSearch,
        specialFilter,
    );

    return (
        <Form>
            <Container className="container--layout" gridClassName="form-content">
                <Col sm={12} md={6} className="col col-12 col-no-pad-mobile mb-4">
                    <SelectField
                        className="slideFromBottom"
                        label="Año"
                        idForm={FORM_ID}
                        name="year"
                        options={years}
                        value={selectedFilter.year}
                        onChange={(option) => handleChange(option, "year")}
                    />
                </Col>

                <Col sm={12} md={6} className="col col-12 col-no-pad-mobile mb-4">
                    <SelectField
                        className="slideFromBottom"
                        label="Mes"
                        idForm={FORM_ID}
                        name="month"
                        options={months}
                        value={selectedFilter.month}
                        onChange={(option) => handleChange(option, "month")}
                    />
                </Col>

                <Col
                    sm={12}
                    md={6}
                    className="col col-12 col-no-pad-mobile"
                    style={{
                        alignSelf: "flex-end",
                        marginBottom: 10,
                    }}>
                    <Button
                        className="btn-outline"
                        label="echecks.clean.filters"
                        type="button"
                        onClick={handleReset}
                        style={{
                            width: "100%",
                        }}
                    />
                </Col>

                <Col
                    sm={12}
                    md={6}
                    className="col col-12 col-no-pad-mobile"
                    style={{
                        alignSelf: "flex-end",
                        marginBottom: 10,
                    }}>
                    <Button
                        bsStyle="primary"
                        label="forms.bankselector.search"
                        type="button"
                        onClick={handleSearch}
                        style={{
                            width: "100%",
                        }}
                    />
                </Col>
            </Container>
        </Form>
    );
};

const mapStateToProps = (state) => ({
    years: selectors.getYears(state),
    months: selectors.getMonths(state),
});

YearMonthFilter.propTypes = {
    dispatch: func.isRequired,
    years: instanceOf(Array),
    months: instanceOf(Array),
    handleCloseSearch: func,
    specialFilter: bool,
};

YearMonthFilter.defaultProps = {
    years: [],
    months: [],
    handleCloseSearch: () => {},
    specialFilter: false,
};

export default connect(mapStateToProps)(
    withFormik({
        validateOnChange: true,
    })(YearMonthFilter),
);
